var map = {
	"./china-cover.webp": 455,
	"./china-high-speed-line-cover.webp": 456,
	"./david-edelstein-N4DbvTUDikw-unsplash.webp": 457,
	"./dong-xie-1vwOXJXxbrE-unsplash.webp": 458,
	"./epaper-background-image.webp": 459,
	"./filios-sazeides-lg3TETZvqv4-unsplash.webp": 460,
	"./finland-cover.webp": 461,
	"./hanson-lu-_8EFj6ISA08-unsplash.webp": 462,
	"./homestay_china.webp": 463,
	"./homestay_japan.webp": 464,
	"./homestay_taiwan.webp": 465,
	"./img_about_us.webp": 466,
	"./img_car_1_desktop.webp": 467,
	"./img_car_2_desktop.webp": 468,
	"./img_car_3_desktop.webp": 469,
	"./img_login.webp": 470,
	"./img_taiwan.webp": 471,
	"./japan-cover.webp": 472,
	"./kevin-healy-Yd2ohmtMmKM-unsplash.webp": 473,
	"./korea-cover.webp": 474,
	"./mesut-kaya-eOcyhe5-9sQ-unsplash.webp": 475,
	"./rawkkim-KKz6NgO69yQ-unsplash.webp": 476,
	"./remi-yuan-JMB3Efb8yoQ-unsplash.webp": 477,
	"./taiwan-cover.webp": 478,
	"./thomas-tucker-au3CYbd7vCU-unsplash.webp": 479,
	"./tsaiga-qhQEyyHWrAQ-unsplash.webp": 480,
	"./wishlist_banner.webp": 481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;